module.exports = __webpack_public_path__ + "static/media/aptosswap.b10e0caf.png";